

const EyeIcon = ({ onClick }) => {
    return (
        <svg
            width="24"
            height="24"
            onClick={onClick}
            className="cursor-pointer"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 85 85"
        >
            <g>
                <g>
                    <path fill="#B8AEC0" className="st0" d="M46.42,19.19c10.39,0.53,21.15,7.23,29.67,17.93c3.75,4.71,3.56,9.51,0.3,14.67
			C61.28,75.62,24.34,75.6,9.14,51.76c-3.31-5.2-2.99-9.77,0.33-14.71C16.39,26.78,30.43,19.14,46.42,19.19z M42.84,57.61
			c8.21,0.42,13-3.21,12.96-12.3c-0.04-8.45-3.77-13.44-12.54-13.63c-8.51-0.19-13.4,3.97-13.4,12.68
			C29.87,52.52,33.19,58,42.84,57.61z"/>
                </g>
            </g>
        </svg>
    )
}
export default EyeIcon;